function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.66665 6.58008C6.01961 5.22606 5.03513 3.68575 4.33331 2.6665C3.19792 4.31416 1.33331 7.31452 1.33331 8.69774C1.33331 10.5183 2.67979 11.9998 4.33331 11.9998C4.81173 11.9998 5.26462 11.8753 5.66665 11.6541",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33331 9.51875C5.33331 11.9895 7.42784 14.0002 9.99998 14.0002C12.5671 14.0002 14.6617 11.9895 14.6666 9.51875C14.6666 7.63692 11.7612 3.565 9.99998 1.3335C8.23381 3.5696 5.33331 7.64152 5.33331 9.51875Z",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

function SvgColorPicker(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-color-picker-16",
    ref: svgRef
  }, props), _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.d54386ad.svg";
export { ForwardRef as ReactComponent };